<div class="upload-download">
  <p
    class="upload-download-edit"
    *ngIf="dataValue?.isEdit && accessType === 'edit'"
    (click)="downloadAndUpload()"
  >
    <span
      class="upload-download-edit-text space-cluster"
      *ngIf="isSpaceClustering"
    >
      <img src="https://cdn.catexpert.ab-inbev.com/assets/images/space-clustering-input.svg" /> {{ 'SHARED.SPACE_CLUSTERING_INPUT' | translate }}</span
    >
    <span class="upload-download-edit-text" *ngIf="!isSpaceClustering"
      ><img src="https://cdn.catexpert.ab-inbev.com/assets/images/edit.svg" /> {{ 'SHARED.MODIFY' | translate }}</span
    >
  </p>
  <span *ngIf="!isSpaceClustering">
    <a
      href="{{ dataValue?.downloadUrl }}"
      *ngIf="dataValue?.downloadUrl && stateService.guideLayerShow !== true"
      (click)="downloadFile($event, dataValue.downloadUrl)"
    >
      <img src="https://cdn.catexpert.ab-inbev.com/assets/images/download.svg" />
      <span class="upload-download-edit-text">{{ 'SHARED.DOWNLOAD_RESULTS' | translate }}</span>
    </a>
    <a *ngIf="stateService.guideLayerShow">
      <img src="https://cdn.catexpert.ab-inbev.com/assets/images/download.svg" />
      <span class="upload-download-edit-text">{{ 'SHARED.DOWNLOAD_RESULTS' | translate }}</span>
    </a>
  </span>
</div>
